export const images = {
  heroExecutive: 'https://cdn.magicpatterns.com/patterns/generated-images/525316c0-a794-4785-b212-8c02772f3dd1.jpg',
  heroFallback: 'https://cdn.magicpatterns.com/patterns/generated-images/a8eea3e0-3366-42c3-acb6-d5220b9f4b80.jpg',
  introArchitecture: 'https://cdn.magicpatterns.com/patterns/generated-images/6fc8be31-edae-4f55-872f-0eb5c1f0f9fe.jpg',
  aboutEditorial: 'https://cdn.magicpatterns.com/patterns/generated-images/89a63fef-c004-463e-8be8-b2b3deeaa4ce.jpg',
};
